/* eslint-disable max-len */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @author: Matthew Rawson @ 04/09/2017 14:47
 * @description: Custom TopUpCard Icon created as a React element in a similar manner to react-icons.
 * @notes: Could be moved to icon font file when that is implemented
 */
import React from "react";
import BaseSvgIcon from "./Base";
export default function TimeLimitedPerk(props) {
    var viewBox = "-5 -5 28 28";
    return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: viewBox }),
        React.createElement("g", { id: "ICON_CLOCK", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { id: "Group-6", stroke: "#4A4A4A" },
                React.createElement("g", { id: "Group-4" },
                    React.createElement("circle", { id: "Oval", cx: "11", cy: "11", r: "11" }))),
            React.createElement("g", { id: "Group-6", transform: "translate(9.000000, 9.000000)", stroke: "#4A4A4A" },
                React.createElement("g", { id: "Group-4" },
                    React.createElement("circle", { id: "Oval", cx: "2", cy: "2", r: "2" }))),
            React.createElement("path", { d: "M11,9 L11,2.5", id: "Path-8", stroke: "#4A4A4A", strokeLinecap: "round" }),
            React.createElement("path", { d: "M13,12 L17,14", id: "Path-9", stroke: "#4A4A4A", strokeLinecap: "round" }))));
}
